import { StyledRow } from "App/global-style";
import { ManualProduct } from "Store/interfaces/products/checkout/ManualProduct";
import { ProductIcon } from "Utils/icons";
import { getProductName } from "Utils/nameUtils/nameUtils";
import { showCoverageGroup } from "Utils/productUtils";
import { useUnleashFeatureFlag } from "Utils/unleash";
import { FeatureFlagTask } from "Utils/unleash/flags";
import React from "react";
import { CardHeaderPrice } from "./CardHeaderPrice";
import { HeaderWrapper, IconWrapper, StyledDesc, Title } from "./styled";

interface Props {
  readonly product: ManualProduct;
  readonly productIcon: boolean;
  readonly displayIssueDate?: boolean;
}

export const ManualCardHeader = ({
  product,
  productIcon,
}: Props): React.ReactElement => {
  const productName = getProductName(product);
  const manualCoverageGroupText = ` - ${product.coverageGroup}`;
  const productDescription = `${product.productIdentifier}, ${product.productDescription}`;
  const isChildCoverageExtraHalfGActive = useUnleashFeatureFlag(
    FeatureFlagTask.SSX_2464_ENABLE_NEWCHILD_HALF_G,
  );

  return (
    <StyledRow className="insurance-details-card__header">
      {productIcon && (
        <IconWrapper className="svg" background="transparent">
          <ProductIcon product={product} label={productName} />
        </IconWrapper>
      )}
      <HeaderWrapper>
        <StyledRow>
          <Title>
            {productName}
            {(showCoverageGroup(product, isChildCoverageExtraHalfGActive) &&
              manualCoverageGroupText) ??
              ""}
          </Title>
        </StyledRow>
        <StyledRow>
          <StyledDesc className="data-hj-suppress">
            {productDescription}
          </StyledDesc>
        </StyledRow>
      </HeaderWrapper>
      <CardHeaderPrice product={product} />
    </StyledRow>
  );
};
